export const parseCurrencyCode = (currencyLabel) => {
  if (!currencyLabel) return null;
  const text = String(currencyLabel).trim();
  const match = text.match(/\(([A-Z]{3})\)/i);
  if (match) return match[1].toUpperCase();
  if (/^[A-Za-z]{3}$/.test(text)) return text.toUpperCase();
  return null;
};

export const formatCompanyAmount = (amount, currencyLabelOrCode) => {
  const code = parseCurrencyCode(currencyLabelOrCode) || String(currencyLabelOrCode || 'USD').toUpperCase();
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: code,
    }).format(Number(amount));
  } catch {
    return `${code} ${Number(amount).toFixed(2)}`;
  }
};

export const getCurrencyLabel = (currencyLabel, currencyCode) => {
  if (currencyLabel) return currencyLabel;
  return currencyCode || 'USD';
};
